import { useEffect, useState } from "react";
import { api } from "../lib/api";

/**
 * Global site-wide contact info. Fetched once per session, cached in a
 * module-level variable so every consumer shares the same reference and
 * only one network request fires across the app.
 */

const DEFAULT = {
  phones: ["+91-8679955515", "+91-7060111949"],
  whatsapp: "918679955515",
  whatsapp_message: "Hi RestroSetup! I'd like to know more about your services.",
  email: "contact@restrosetup.com",
  address: "",
  instagram_url: "",
  facebook_url: "",
  twitter_url: "",
  linkedin_url: "",
  youtube_url: "",
};

let cached = null;
let inflight = null;
const listeners = new Set();

async function fetchOnce() {
  if (cached) return cached;
  if (!inflight) {
    inflight = api.get("/site/contact")
      .then((r) => { cached = { ...DEFAULT, ...(r.data || {}) }; return cached; })
      .catch(() => { cached = DEFAULT; return cached; })
      .finally(() => { listeners.forEach((cb) => cb(cached)); });
  }
  return inflight;
}

/** Clear cache — called after admin saves a new value so all consumers refresh. */
export function invalidateSiteContact() {
  cached = null;
  inflight = null;
  fetchOnce();
}

export default function useSiteContact() {
  const [contact, setContact] = useState(cached || DEFAULT);
  useEffect(() => {
    let mounted = true;
    fetchOnce().then((c) => { if (mounted) setContact(c); });
    const cb = (c) => mounted && setContact(c);
    listeners.add(cb);
    return () => { mounted = false; listeners.delete(cb); };
  }, []);
  return contact;
}

/** Utility helpers used across components. */
export const digitsOnly = (s) => (s || "").replace(/[^0-9]/g, "");

export function whatsappLink(contact) {
  const phone = digitsOnly(contact.whatsapp || contact.phones?.[0] || "");
  const msg = encodeURIComponent(contact.whatsapp_message || "");
  return phone ? `https://wa.me/${phone}${msg ? `?text=${msg}` : ""}` : null;
}
